var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('h4',[_vm._v(_vm._s(_vm.mainFields?.title?.value))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.mainFields?.description?.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }